var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProduct = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#003865",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.798 9.5.848 3.5a3.609 3.609 0 0 1-.72 3.12 3.778 3.778 0 0 1-2.948 1.38H6.161a3.778 3.778 0 0 1-2.947-1.38A3.609 3.609 0 0 1 2.493 13l.85-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.535 11.5h-2.16c-1.616.016-2.94-1.25-2.956-2.829V6.5c0-.552.458-1 1.023-1h11.256c.565 0 1.023.448 1.023 1v2.171c-.017 1.579-1.34 2.845-2.956 2.829h-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.535 12c0 .828.687 1.5 1.535 1.5.847 0 1.535-.672 1.535-1.5s-.688-1.5-1.535-1.5c-.848 0-1.535.672-1.535 1.5ZM8.876 2.5h2.388c.753 0 1.364.597 1.364 1.333V5.5H7.512V3.833c0-.736.61-1.333 1.364-1.333Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProduct);
export default ForwardRef;